import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
let UploadAddon = class UploadAddon extends Vue {
  constructor() {
    super(...arguments);
    this.answer = [];
    this.previewSrcList = [];
  }
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer.map(as => {
          return {
            url: as,
            isImage: this.testIsImage(as),
            fileName: this.getfileName(as)
          };
        });
        this.previewSrcList = value.answer.map(as => {
          return as;
        });
      }
    }
  }
  testIsImage(url) {
    let imgs = ["png", "jpg", "jpeg", "webp"];
    return imgs.some(ment => {
      return url.indexOf(ment) >= 0;
    });
  }
  getfileName(url) {
    let splits = url.split("/");
    return decodeURIComponent(splits[splits.length - 1]);
  }
  openImage(url) {
    window.open(url);
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], UploadAddon.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], UploadAddon.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], UploadAddon.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
}), Prop({
  type: Object,
  default: {}
})], UploadAddon.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], UploadAddon.prototype, "dataChage", null);
UploadAddon = __decorate([Component({
  name: "uploadAddon",
  components: {
    PicUpload
  }
})], UploadAddon);
export default UploadAddon;